import React, { useState, useEffect, useContext, useRef } from "react";
import { FilterBarContainer } from "./FilterBarStyled";
import search from './../../utils/images/search.png';
import { FormattedMessage } from 'react-intl';
import 'primeicons/primeicons.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.css';

import '../../index.css';
import { getAgeRange, getCategories, getCountries, getLanguages, getNetworks, getPriceRange } from "../../api/filtersApi";

import arrow from './../../utils/images/arrow_down.png';
import arrowPink from './../../utils/images/arrow_down_pink.svg';
import { LangContext } from "../../context/langContext";
import { useNavigate } from "react-router-dom";
import { FiltersContext } from "../../context/filtersContext";
import { getInfluencersByRate } from "../../api/influencerApi";
import { getConvertCurrency } from "../../api/exchangeApi";
import { CurrencyContext } from "../../context/currencyContext";
import { formatNumber } from "../../services/generalSevices";


export default function FilterBar() {

    const filter1Ref = useRef(null);
    const filter2Ref = useRef(null);
    const filter3Ref = useRef(null);
    const filter4Ref = useRef(null);

    const navigate = useNavigate();

    const { currency } = useContext(CurrencyContext);

    const { locale } = useContext(LangContext);

    const { languageFilter, setLanguageFilter, verifiedFilter, setVerifiedFilter, genderFilter, setGenderFilter, ageFilter, setAgeFilter, networkFilter, setNetworkFilter, categoryFilter, setCategoryFilter, countryFilter, setCountryFilter, priceFilter, setPriceFilter, queryPrice, setQueryPrice, queryPriceId, setQueryPriceId, inputFilter, setInputFilter } = useContext(FiltersContext);


    const [showFilterBy, setShowFilterBy] = useState(false);
    const [showFilterByLanguage, setShowFilterByLanguage] = useState(false);
    const [showFilterByVerified, setShowFilterByVerified] = useState(false);
    const [showFilterByGender, setShowFilterByGender] = useState(false);
    const [showFilterByAge, setShowFilterByAge] = useState(false);
    const [showFilterByNetwork, setShowFilterByNetwork] = useState(false);

    const [showCategories, setShowCategories] = useState(false);
    const [showCountries, setShowCountries] = useState(false);
    const [showPrices, setShowPrices] = useState(false);

    const [languagesOptions, setLanguagesOptions] = useState([]);
    const [ageOptions, setAgeOptions] = useState([]);
    const [networksOptions, setNetworksOptions] = useState([]);
    const [categoriesOptions, setCategoriesOptions] = useState([]);
    const [countriesOptions, setCountriesOptions] = useState([]);
    const [pricesOptions, setPricesOptions] = useState([]);

    const [auxPricesOptions, setAuxPricesOptions] = useState([]);

    let auxCurrency = currency?.symbol;

    useEffect(() => {

        getLanguages().then((response) => {
            setLanguagesOptions(response);
        })
        getAgeRange().then((response) => {
            setAgeOptions(response);
        })
        getNetworks().then((response) => {
            setNetworksOptions(response);
        })
        getCategories().then((response) => {
            setCategoriesOptions(response);
        })
        getCountries().then((response) => {
            setCountriesOptions(response);
        })
        getPriceRange().then((response) => {
            setPricesOptions(response);
        })
    }, [])


    useEffect(() => {
        function handleClickOutside1(event) {
            if (filter1Ref.current && !filter1Ref.current.contains(event.target)) {
                setShowFilterBy(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside1);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside1);
        };
    }, [filter1Ref])

    useEffect(() => {
        function handleClickOutside2(event) {
            if (filter2Ref.current && !filter2Ref.current.contains(event.target)) {
                setShowCategories(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside2);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside2);
        };
    }, [filter2Ref])

    useEffect(() => {
        function handleClickOutside2(event) {
            if (filter3Ref.current && !filter3Ref.current.contains(event.target)) {
                setShowCountries(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside2);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside2);
        };
    }, [filter3Ref])

    useEffect(() => {
        function handleClickOutside2(event) {
            if (filter4Ref.current && !filter4Ref.current.contains(event.target)) {
                setShowPrices(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside2);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside2);
        };
    }, [filter4Ref])

    const handlerFilter = () => {
        navigate('/influencers')
    }

    const handlerLanguageFilter = (event, language) => {

        const auxLanguageFilter = [...languageFilter];
        if (event.target.checked) {
            auxLanguageFilter.push(language.id);
            setLanguageFilter(auxLanguageFilter);
        } else {
            const newLanguage = auxLanguageFilter.filter(lang => lang !== language.id);
            setLanguageFilter(newLanguage)
        }
    }

    const handlerVerifiedFilter = (event, verified) => {
        const auxVerifiedFilter = [...verifiedFilter];
        if (event.target.checked) {
            auxVerifiedFilter.push(verified);
            setVerifiedFilter(auxVerifiedFilter);
        } else {
            const verifiedStatus = auxVerifiedFilter.filter(lang => lang !== verified);
            setVerifiedFilter(verifiedStatus)
        }
    }

    const handlerGenderFilter = (event, gender) => {
        const auxGenderFilter = [...genderFilter];
        if (event.target.checked) {
            auxGenderFilter.push(gender);
            setGenderFilter(auxGenderFilter);
        } else {
            const newGender = auxGenderFilter.filter(gen => gen !== gender);
            setGenderFilter(newGender)
        }
    }

    const handlerAgeFilter = (event, age) => {
        const auxAgeFilter = [...ageFilter];
        if (event.target.checked) {
            auxAgeFilter.push(age);
            setAgeFilter(auxAgeFilter);
        } else {
            const newAge = auxAgeFilter.filter(ageRange => ageRange !== age);
            setAgeFilter(newAge)
        }
    }

    const handlerNetworkFilter = (event, network) => {
        const auxNetworkFilter = [...networkFilter];
        if (event.target.checked) {
            auxNetworkFilter.push(network);
            setNetworkFilter(auxNetworkFilter);
        } else {
            const newNetwork = auxNetworkFilter.filter(net => net !== network);
            setNetworkFilter(newNetwork);
        }
    }

    const handlerCategoryFilter = (event, category) => {
        const auxCategoryFilter = [...categoryFilter];
        if (event.target.checked) {
            auxCategoryFilter.push(category);
            setCategoryFilter(auxCategoryFilter);
        } else {
            const newCategory = auxCategoryFilter.filter(cat => cat !== category);
            setCategoryFilter(newCategory)
        }
    }

    const handlerCountryFilter = (event, country) => {
        const auxCountryFilter = [...countryFilter];
        if (event.target.checked) {
            auxCountryFilter.push(country);
            setCountryFilter(auxCountryFilter);
        } else {
            const newCountry = auxCountryFilter.filter(count => count !== country);
            setCountryFilter(newCountry)
        }
    }



    const handlerPriceFilter = (event, price) => {

        if (event.target.checked) {
            switch (price.id) {
                case (1):
                    setQueryPrice([...queryPrice, 'and(rate.lt.10)'])
                    setQueryPriceId([...queryPriceId, 1])
                    break;
                case (2):
                    setQueryPrice([...queryPrice, 'and(rate.gte.10,rate.lte.24)'])
                    setQueryPriceId([...queryPriceId, 2])
                    break;
                case (3):
                    setQueryPrice([...queryPrice, 'and(rate.gte.25,rate.lte.49)'])
                    setQueryPriceId([...queryPriceId, 3])
                    break;
                case (4):
                    setQueryPrice([...queryPrice, 'and(rate.gte.50,rate.lte.99)'])
                    setQueryPriceId([...queryPriceId, 4])
                    break;
                default:
                    setQueryPrice([...queryPrice, 'and(rate.gte.100)'])
                    setQueryPriceId([...queryPriceId, 5])
            }

        } else {
            switch (price.id) {
                case (1):
                    queryPrice.splice(queryPrice.indexOf('and(rate.lt.10)'), 1)
                    queryPriceId.splice(queryPriceId.indexOf(1), 1)
                    setQueryPrice([...queryPrice])
                    setQueryPriceId([...queryPriceId])
                    break;
                case (2):
                    queryPrice.splice(queryPrice.indexOf('and(rate.gte.10,rate.lte.24)'), 1)
                    queryPriceId.splice(queryPriceId.indexOf(2), 1)
                    setQueryPrice([...queryPrice])
                    setQueryPriceId([...queryPriceId])
                    break;
                case (3):
                    queryPrice.splice(queryPrice.indexOf('and(rate.gte.25,rate.lte.49)'), 1)
                    queryPriceId.splice(queryPriceId.indexOf(3), 1)
                    setQueryPrice([...queryPrice])
                    setQueryPriceId([...queryPriceId])
                    break;
                case (4):
                    queryPrice.splice(queryPrice.indexOf('and(rate.gte.50,rate.lte.99)'), 1)
                    queryPriceId.splice(queryPriceId.indexOf(4), 1)
                    setQueryPrice([...queryPrice])
                    setQueryPriceId([...queryPriceId])
                    break;
                default:
                    queryPrice.splice(queryPrice.indexOf('and(rate.gte.100)'), 1)
                    queryPriceId.splice(queryPriceId.indexOf(5), 1)
                    setQueryPrice([...queryPrice])
                    setQueryPriceId([...queryPriceId])
            }
        }
    }

    useEffect(() => {
        let influencersId = []

        if (queryPrice.length > 0) {
            getInfluencersByRate({ query: queryPrice.toString() }).then((response) => {
                response.map((influencer) => {
                    influencersId.push(influencer.influincr)
                })

                const auxPriceFilter = new Set(influencersId)
                let result = [...auxPriceFilter]

                setPriceFilter(result);
            })
        }
    }, [queryPrice])

    useEffect(() => {
        if (languageFilter.length > 0 || verifiedFilter.length > 0 || genderFilter.length > 0 || ageFilter.length > 0 || networkFilter.length > 0 || categoryFilter.length > 0 || countryFilter.length > 0 || priceFilter.length > 0) {
            navigate('/influencers')
        }

    }, [languageFilter, verifiedFilter, genderFilter, ageFilter, networkFilter, categoryFilter, countryFilter, priceFilter])

    return (
        <FilterBarContainer>
            <div className="filters">

                <div className="filterContainer">
                    <div className="filter" ref={filter1Ref}>
                        <div className="filterBy" onClick={() => {
                            setShowFilterBy(!showFilterBy)
                        }}>
                            <p><FormattedMessage id="filter_title_1" defaultMessage="Filtrar por" /></p>
                            <img src={arrowPink} alt="down" className="down" />
                        </div>
                        {(showFilterBy) && (
                            <div className="subFilter" /* ref={filter1Ref} */>

                                <div>
                                    <div className="subfilterBy">
                                        <p><FormattedMessage id="filter_title_1_subtitle_6" defaultMessage="Idioma" /></p>
                                        <img src={arrowPink} alt="down" className="down" onClick={() => { setShowFilterByLanguage(!showFilterByLanguage) }} />
                                    </div>
                                    {(showFilterByLanguage) && (<div className="options">

                                        {languagesOptions.map((language) => (<label for={language.name} className='option'> <input type="checkbox" id={language.name} name="age" value={language.name} onChange={(event) => {
                                            handlerLanguageFilter(event, language)
                                        }} checked={languageFilter.includes(language.id)} />{(locale === 'es-CO') ? language.nombre : language.name}</label>))}

                                    </div>)}
                                </div>

                                <div>
                                    <div className="subfilterBy">
                                        <p><FormattedMessage id="filter_title_1_subtitle_7" defaultMessage="Verificado" /></p>
                                        <img src={arrowPink} alt="down" className="down" onClick={() => { setShowFilterByVerified(!showFilterByVerified) }} />
                                    </div>
                                    {(showFilterByVerified) && (<div className="options">

                                        <label htmlFor='yes' className='option'> <input type="checkbox" id='yes' name="verified" value='yes' checked={verifiedFilter.includes('yes')} onChange={(event) => {
                                            handlerVerifiedFilter(event, 'yes')
                                        }} /> <FormattedMessage id="filter_title_1_subtitle_7_option_1" defaultMessage="Si" /></label>

                                        <label htmlFor='no' className='option'> <input type="checkbox" id='no' name="verified" value='no' checked={verifiedFilter.includes('no')} onChange={(event) => { handlerVerifiedFilter(event, 'no') }} /> <FormattedMessage id="filter_title_1_subtitle_7_option_2" defaultMessage="No" /></label>

                                    </div>)}
                                </div>

                                <div>
                                    <div className="subfilterBy">
                                        <p><FormattedMessage id="filter_title_1_subtitle_5" defaultMessage="Género" /></p>
                                        <img src={arrowPink} alt="down" className="down" onClick={() => { setShowFilterByGender(!showFilterByGender) }} />
                                    </div>
                                    {(showFilterByGender) && (<div className="options">

                                        <label htmlFor='female' className='option'> <input type="checkbox" id='female' name="gender" value='female' checked={genderFilter.includes('female')} onChange={(event) => { handlerGenderFilter(event, 'female') }} /> <FormattedMessage id="filter_title_1_subtitle_5_option_1" defaultMessage="Femenino" /></label>

                                        <label htmlFor='male' className='option'> <input type="checkbox" id='male' name="gender" value='male' checked={genderFilter.includes('male')} onChange={(event) => { handlerGenderFilter(event, 'male') }} /> <FormattedMessage id="filter_title_1_subtitle_5_option_2" defaultMessage="Masculino" /></label>

                                        <label htmlFor='other' className='option'> <input type="checkbox" id='other' name="gender" value='other' checked={genderFilter.includes('other')} onChange={(event) => { handlerGenderFilter(event, 'other') }} /> <FormattedMessage id="filter_title_1_subtitle_5_option_3" defaultMessage="Otro" /></label>
                                    </div>)}
                                </div>

                                <div>
                                    <div className="subfilterBy">
                                        <p><FormattedMessage id="filter_title_1_subtitle_4" defaultMessage="Edad" /></p>
                                        <img src={arrowPink} alt="down" className="down" onClick={() => { setShowFilterByAge(!showFilterByAge) }} />
                                    </div>
                                    {(showFilterByAge) && (<div className="options">

                                        {ageOptions.map((age) => (<label htmlFor={age.range} className='option'> <input type="checkbox" id={age.range} name="age" value={age.range} checked={ageFilter.includes(age.range)} onChange={(event) => { handlerAgeFilter(event, age.range) }} /> {age.range}</label>))}

                                    </div>)}
                                </div>

                                <div>
                                    <div className="subfilterBy">
                                        <p><FormattedMessage id="filter_title_1_subtitle_8" defaultMessage="Redes sociales" /></p>
                                        <img src={arrowPink} alt="down" className="down" onClick={() => { setShowFilterByNetwork(!showFilterByNetwork) }} />
                                    </div>
                                    {(showFilterByNetwork) && (<div className="options">

                                        {networksOptions.map((network) => (<label htmlFor={network.name} className='option'> <input type="checkbox" id={network.name} name="age" value={network.name} checked={networkFilter.includes(network.name)} onChange={(event) => { handlerNetworkFilter(event, network.name) }} /> {network.name}</label>))}

                                    </div>)}
                                </div>

                            </div>

                        )}

                    </div>
                </div>

                <div className="filterContainer otherFilterContainer">
                    <div className="filter" ref={filter2Ref}>
                        <div className="filterBy otherFilter" onClick={() => { setShowCategories(!showCategories) }}>
                            <p><FormattedMessage id="filter_title_2" defaultMessage="Categoría" /></p>
                            <img src={arrow} alt="down" className="down" />
                        </div>

                        {(showCategories) && (
                            <div className="subFilter" /* ref={filter2Ref} */>
                                <div className="options categoryOptions">

                                    {categoriesOptions.map((category) => (<label htmlFor={category.name} className='option'> <input type="checkbox" id={category.name} name="category" value={category.name} checked={categoryFilter.includes(category.id)} onChange={(event) => { handlerCategoryFilter(event, category.id) }} /> {(locale === 'es-CO') ? category.nombre : category.name}</label>))}

                                </div>
                            </div>)}
                    </div>
                </div>

                <div className="filterContainer otherFilterContainer">
                    <div className="filter" ref={filter3Ref}>
                        <div className="filterBy otherFilter" onClick={() => { setShowCountries(!showCountries) }}>
                            <p><FormattedMessage id="filter_title_3" defaultMessage="País" /></p>
                            <img src={arrow} alt="down" className="down" />
                        </div>

                        {(showCountries) && (
                            <div className="subFilter" /* ref={filter3Ref} */>
                                <div className="options countryOptions">

                                    {countriesOptions.map((country) => (<label htmlFor={country.name} className='option'> <input type="checkbox" id={country.name} name="country" value={country.name} checked={countryFilter.includes(country.id)} onChange={(event) => { handlerCountryFilter(event, country.id) }} /> {(locale === 'es-CO') ? country.nombre : country.name}</label>))}

                                </div>
                            </div>)}

                    </div>
                </div>

                <div className="filterContainer otherFilterContainer">
                    <div className="filter" ref={filter4Ref}>
                        <div className="filterBy otherFilter" onClick={() => { setShowPrices(!showPrices) }}>
                            <p><FormattedMessage id="filter_title_4" defaultMessage="Precio" /></p>
                            <img src={arrow} alt="down" className="down" />
                        </div>

                        {(showPrices) && (
                            <div className="subFilter" >
                                <div className="options">

                                    {pricesOptions.map((price) => (<label htmlFor={price.range} className='option' key={price.id}> <input type="checkbox" id={price.range} name="category" value={price.range} onChange={(event) => { handlerPriceFilter(event, price) }} /> {(locale === 'es-CO') ? price.rango : price.range}</label>))}

                                </div>
                            </div>)}
                    </div>
                </div>

                <div className="filterContainer">
                    <div className="filter">
                        <div className="textFilter">
                            <input type="text" className="nameText" value={inputFilter} onChange={(event) => { setInputFilter(event.target.value) }} />
                            <img src={search} alt="search" className="search" onClick={handlerFilter} />
                        </div>
                    </div>
                </div>

            </div>
        </FilterBarContainer>
    )
}